/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Admin_Revoked_DescInputs */



/**
* | output |
* | --- |
* | "The member is no longer an organisation admin." |
*
* @param {Audit_Details_Member_Admin_Revoked_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_admin_revoked_desc = /** @type {((inputs?: Audit_Details_Member_Admin_Revoked_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Admin_Revoked_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Mitglied ist nicht mehr Organisations-Admin.")
	return /** @type {LocalizedString} */ ("The member is no longer an organisation admin.")
});